import { CheckIcon } from '@heroicons/react/20/solid';

type Props = {
  title: string;
  tips: string[];
  hasCheckIcon?: boolean;
};

export const CreateListingInfoSubsection = ({
  tips,
  title,
  hasCheckIcon = false,
}: Props) => {
  return (
    <div className="hidden w-fit max-w-[272px] flex-col gap-4 pl-12 lg:flex">
      <h3 className="w-full text-body-md font-semibold">{title}</h3>
      {tips.map((t, i) =>
        hasCheckIcon ? (
          <div className="flex items-center gap-4" key={i}>
            <div className="size-8">
              <CheckIcon className="size-8  text-brand-secondary" />
            </div>
            <span className="text-body-sm text-text-muted">{t}</span>
          </div>
        ) : (
          <span className="text-body-sm text-text-muted" key={i}>
            {t}
          </span>
        )
      )}
    </div>
  );
};
